import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar2 } from "./components/Navbar2";
import { Header102 } from "./components/Header102";
import { Layout239 } from "./components/Layout239";
import { Cta7 } from "./components/Cta7";
import { Layout254 } from "./components/Layout254";
import { Stats25 } from "./components/Stats25";
import { Team7 } from "./components/Team7";
import { Testimonial4 } from "./components/Testimonial4";
import { Logo6 } from "./components/Logo6";
import { Layout1 } from "./components/Layout1";
import { Faq6 } from "./components/Faq6";
import { Footer5 } from "./components/Footer5";
import AdoptionForm from "./components/Forms/Adoption"; 
import DonationForm from "./components/Forms/Donation"; 
import VolunteerForm from "./components/Forms/Volunteer"; 

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Define your routes here */}
        <Route path="/" element={
          <div>
            <Navbar2 />
            <Header102 />
            <Layout239 />
            <Cta7 />
            <Layout254 />
            <Stats25 />
            <Layout1 />
            <Team7 />
            <Testimonial4 />
            <Logo6 />
            <Faq6 />
            {/* <Cta4 /> */}
            <Footer5 />
          </div>
        } />
        <Route path="/services" element={<Layout239 />} />
        <Route path="/team" element={<Team7 />} />
        <Route path="/adoption" element={<AdoptionForm />} />
        <Route path="/donation" element={<DonationForm />} />
        <Route path="/volunteer" element={<VolunteerForm />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
